import { useTranslation } from 'react-i18next';
import { cn } from 'utils/classnames';

interface LoaderProps {
  text?: string;
  variant?: 'page' | 'inline';
  className?: string;
}

export const Loader = ({ text, variant = 'page', className }: LoaderProps) => {
  const { t } = useTranslation();
  const isPage = variant === 'page';

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex flex-col items-center justify-center',
        isPage ? 'pointer-events-none fixed inset-0 z-40 gap-4' : 'w-full gap-3 py-6',
        className
      )}
    >
      <div className={cn('relative', isPage ? 'h-14 w-14' : 'h-8 w-8')}>
        <div
          className={cn(
            'absolute inset-0 rounded-full border-slate-200',
            isPage ? 'border-4' : 'border-[3px]'
          )}
        />
        <div
          className={cn(
            'absolute inset-0 animate-spin rounded-full border-transparent border-t-blue-500 border-r-blue-500',
            isPage ? 'border-4' : 'border-[3px]'
          )}
        />
        <div className="absolute inset-[32%] animate-pulse rounded-full bg-blue-500/30" />
      </div>
      <p className={cn('animate-pulse font-medium text-slate-500', isPage ? 'text-sm' : 'text-xs')}>
        {text ?? t('app.loading')}
      </p>
    </div>
  );
};
